import LookUpModel from "./LookUpModel";

export default class ConvenzioniModel extends LookUpModel {
    constructor(data: Partial<ConvenzioniModel>) {
        super(data);

        this.update(data);
    }
}
